module.exports = __webpack_public_path__ + "static/media/ETH_USDT.807dc578.svg";